<div  mat-dialog-title>{{data.title}}<div class="spacer"></div><mat-icon mat-dialog-close>close</mat-icon></div>
<div mat-dialog-content>
  <div>{{ data.message }}</div>
</div>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-dialog-close>{{"MAKE_ADMIN_DIALOG.cancel" | translate}}</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">{{ data.adding ? ('MAKE_ADMIN_DIALOG.confirm' | translate) : ('MAKE_ADMIN_DIALOG.remove' | translate)}}</button>
</mat-dialog-actions>
